import React from "react";
import { getThemeColors, getInitials } from "./helper";
import { AvatarProps } from "./types";

export default function Avatar({
  name,
  fontFamily = "Arial, sans-serif",
  size = 50,
  shape = "circle",
  style = {},
  backgroundColor,
  textColor,
  fontSize,
  padding = "4px",
  useNameBasedColor = false,
  theme = "dark",
  ...rest
}: AvatarProps): React.ReactElement {
  const { primary, contrast } = getThemeColors({
    name,
    useNameBasedColor,
    theme,
  });
  const initials = getInitials(name);
  let borderRadius: string;

  if (shape === "circle") {
    borderRadius = "50%";
  } else if (shape === "square") {
    borderRadius = "0%";
  } else {
    // shape is 'rounded' — assert and use rest.radius
    const radius = (rest as { radius: string | number }).radius;
    borderRadius = typeof radius === "number" ? `${radius}px` : radius;
  }

  return (
    <div
      style={{
        backgroundColor: backgroundColor ?? primary,
        color: textColor ?? contrast,
        height: size,
        width: size,
        borderRadius,
        fontFamily,
        textAlign: "center",
        lineHeight: `${size}px`, // vertical alignment
        textTransform: "uppercase",
        fontSize: fontSize ?? `clamp(30px, ${size * 0.5}px, 40px)`,
        padding,
        ...style, // allow override
      }}
    >
      {initials}
    </div>
  );
}
